import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PowerpointSvg = function PowerpointSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 25 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#powerpoint__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#ED6C47",
        d: "M14.2 13 12.7 2h-.112A9.917 9.917 0 0 0 2.7 11.888V12z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FF8F6B",
        d: "M12.812 2H12.7v10l5 2 5-2v-.112A9.917 9.917 0 0 0 12.812 2"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#D35230",
        d: "M22.7 12v.11A9.92 9.92 0 0 1 12.81 22h-.22a9.92 9.92 0 0 1-9.89-9.89V12z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M13.2 6.915v10.67a.92.92 0 0 1-.915.915H5.06a9.807 9.807 0 0 1-2.36-6.39v-.22A9.78 9.78 0 0 1 4.31 6.5c.11-.17.225-.34.35-.5h7.625a.92.92 0 0 1 .915.915",
        opacity: 0.1
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M12.7 7.415v10.67a.92.92 0 0 1-.915.915h-6.27a9 9 0 0 1-.455-.5 9.807 9.807 0 0 1-2.36-6.39v-.22A9.78 9.78 0 0 1 4.31 6.5h7.475a.92.92 0 0 1 .915.915",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M12.7 7.415v9.67a.92.92 0 0 1-.915.915H4.66a9.8 9.8 0 0 1-1.96-5.89v-.22A9.78 9.78 0 0 1 4.31 6.5h7.475a.92.92 0 0 1 .915.915",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M12.2 7.415v9.67a.92.92 0 0 1-.915.915H4.66a9.8 9.8 0 0 1-1.96-5.89v-.22A9.78 9.78 0 0 1 4.31 6.5h6.975a.92.92 0 0 1 .915.915",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#powerpoint__b)",
        d: "M11.284 6.5H2.116a.916.916 0 0 0-.916.917v9.167c0 .506.41.916.916.916h9.168c.506 0 .916-.41.916-.916V7.417a.917.917 0 0 0-.916-.917"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M6.8 8.944a2.52 2.52 0 0 1 1.669.49 1.75 1.75 0 0 1 .58 1.416 1.97 1.97 0 0 1-.286 1.058 1.9 1.9 0 0 1-.813.72 2.76 2.76 0 0 1-1.224.256h-1.16v2.155H4.38V8.944zm-1.234 3.01h1.022c.324.023.645-.073.903-.27a1 1 0 0 0 .306-.789q0-1.007-1.171-1.007h-1.06z"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "powerpoint__b",
        x1: 3.111,
        x2: 10.289,
        y1: 5.784,
        y2: 18.216,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CA4C28"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.5,
          stopColor: "#C5401E"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#B62F14"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "powerpoint__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M.2 0h24v24H.2z"
        })
      })]
    })]
  });
};
export var Powerpoint = function Powerpoint(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: PowerpointSvg
  }));
};